import React from 'react'
import PropTypes from 'prop-types'

import {
  Edit,
  Close,
  Excel,
  Ppt,
  Csv,
  Draft,
  Plus,
  Sandbox,
  Observations,
  Insights,
  Maximize,
  Minimize,
  HamburderMenu,
} from './icons'
import { Button, IconButton, LinkButton } from './style'

const MuiButtons = (props) => {
  const { buttonType = 'button', title = '' } = props
  return (
    <>
      {buttonType === 'close' && (
        <IconButton {...props} variant='outlined'>
          <Close />
        </IconButton>
      )}
      {buttonType === 'close2' && (
        <IconButton {...props} variant='standard'>
          <Close />
        </IconButton>
      )}
      {buttonType === 'close3' && (
        <IconButton {...props} variant='text'>
          <Close />
        </IconButton>
      )}
      {buttonType === 'observations' && (
        <IconButton {...props} variant='outlined'>
          <Observations />
        </IconButton>
      )}
      {buttonType === 'insights' && (
        <IconButton {...props} variant='outlined'>
          <Insights />
        </IconButton>
      )}
      {buttonType === 'maximize' && (
        <IconButton {...props} variant='outlined'>
          <Maximize />
        </IconButton>
      )}
      {buttonType === 'minimize' && (
        <IconButton {...props} variant='outlined'>
          <Minimize />
        </IconButton>
      )}
      {buttonType === 'hamburderMenu' && (
        <IconButton {...props} variant='text'>
          <HamburderMenu />
        </IconButton>
      )}

      {buttonType === 'exportToExcel' && (
        <Button {...props} startIcon={<Excel />} variant='outlined'>
          {' '}
          Export{' '}
        </Button>
      )}
      {buttonType === 'draft' && (
        <LinkButton {...props} startIcon={<Draft />} variant='outlined' color='dark' size='sm'>
          {' '}
          Draft
        </LinkButton>
      )}
      {buttonType === 'initiateNewProject' && (
        <LinkButton {...props} startIcon={<Plus />} variant='contained' color='primary' size='sm'>
          {' '}
          Initiate New Project
        </LinkButton>
      )}
      {buttonType === 'addNewUser' && (
        <LinkButton {...props} startIcon={<Plus />} variant='contained' color='primary' size='sm'>
          {' '}
          Add New User
        </LinkButton>
      )}
      {buttonType === 'exportToPPT' && (
        <LinkButton {...props} startIcon={<Ppt />} variant='outlined' color='dark' size='sm'>
          {' '}
          Export To PPT
        </LinkButton>
      )}
      {buttonType === 'exportToCSV' && (
        <LinkButton {...props} startIcon={<Csv />} variant='outlined' color='dark' size='sm'>
          {' '}
          Export To CSV
        </LinkButton>
      )}
      {buttonType === 'sandbox' && (
        <LinkButton {...props} startIcon={<Sandbox />} variant='contained' color='dark' size='sm'>
          {' '}
          Sandbox
        </LinkButton>
      )}
      {buttonType === 'editButton' && (
        <Button {...props} startIcon={<Edit />} variant='outlined'>
          {' '}
          {title}
        </Button>
      )}
      {buttonType === 'button' && <LinkButton {...props}> {title}</LinkButton>}
    </>
  )
}

MuiButtons.propTypes = {
  buttonType: PropTypes.string,
  title: PropTypes.string,
}

export default MuiButtons
